import { columnName, formatValue, typeSpecificProps } from "helpers/reports";
import React from "react";
import CommonReport from "../commonReport";
import ResourceDetails from "./resourceDetails";

export default class IncomesAndExpensesReport extends CommonReport {
    tableExtraProps = () => {
        return {
            initialState: {
                hiddenColumns: ["cars", "drivers", "trailers", "bids"],
            },
        };
    };

    showResourceDetails = (original) => {
        return this.props.addModal({
            name: "default",
            windowMod: "wide",
            withoutHeader: true,
            CustomBody: ResourceDetails,
            bodyData: {
                cars: original.cars,
                drivers: original.drivers,
                trailers: original.trailers,
                bids: original.bids,
            },
        });
    };

    cellProps = (column) => {
        return {
            Header: column.label,
            accessor: columnName(column),
            show: !column.isAdditionalColumn,
            Cell: (props) => {
                switch (props.column.id) {
                    case "carNumber":
                        return (
                            <div
                                className="long-text link"
                                onClick={() => this.showResourceDetails(props.row.original)}
                            >
                                {props.value}
                            </div>
                        );
                    default:
                        return <div className="long-text">{formatValue(props.value, column.clrType)}</div>;
                }
            },
            Footer: () => {
                const defaultFooter = this.footerVal(column);
                const { footer } = this.props.data || {};
                switch (column.propertyName) {
                    case "Balance": {
                        const { balance } = footer;
                        return <span key="value">{formatValue(balance, column.clrType)}</span>;
                    }
                    default:
                        return defaultFooter;
                }
            },
            ...typeSpecificProps(column),
        };
    };

    extractColumns = () => {
        const { columns } = this.props.data || {};
        return columns.map((column) => {
            return this.cellProps(column);
        });
    };
}
